import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ButtonService } from '../../services';
import { ButtonSet } from '../../models';
import { AngularFireAuth } from '@angular/fire/auth';

@Component({
  selector: 'add-buttonset-dialog',
  templateUrl: './add-buttonset-dialog.html',
  styles: ['.mat-form-field { display: block }']
})
export class AddButtonSetDialog implements OnInit {
  isLinear = true;
  userId: string;
  firstFormGroup: FormGroup;

  constructor(
    private _fb: FormBuilder,
    public dialogRef: MatDialogRef<AddButtonSetDialog>,
    private buttonService: ButtonService,
    private authService: AngularFireAuth,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.firstFormGroup = this._fb.group({
      name: '',
      description: '',
      buttons: []
    });

    this.authService.authState.subscribe(user => {
      if (user) {
        this.userId = user.uid;
        // this.buttonService.getForUser(user.uid).subscribe(b => (this.buttonSets = b));
      }
    });
  }

  onSaveClick(): void {
    if (this.userId) {
      const buttonSet = this.firstFormGroup.value as ButtonSet;
      buttonSet.buttons = null; // this.buttonService.getDefaultButtonSet().buttons;
      buttonSet.userId = this.userId;

      this.buttonService.add(buttonSet).subscribe(e => {
        this.dialogRef.close(e);
      });
    } else {
      alert('ButtonSet not created as User Id was not available.');
      console.error('User Id was not available.');
      this.dialogRef.close(null);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
